module.exports = __webpack_public_path__ + "static/logo-large-78cc8cdee438e0574deb37c8410e5ba5.png";